import { Navigate } from 'react-router-dom';
import { Page, type DispatchedAction } from '@eo/shared';

import { useAppSelector } from '../../app/store';
import { ClientDetailContent } from './ClientDetailContent';
import { clientDetailController } from './controller';
import type { ClientDetailState } from './types';

// Capacity configuration is admin-only on every route it touches; the gate here
// is UX, and the backend re-checks on each one.
export default function ClientDetailPage() {
  const me = useAppSelector((s) => s.staff.me);
  if (!me?.isAdmin) return <Navigate to="/" replace />;

  return (
    <Page<ClientDetailState> controller={clientDetailController as never}>
      {({ data, actions }) => (
        <ClientDetailContent
          data={data}
          onUpsertBudget={(payload) => actions.upsertBudget(payload) as Promise<DispatchedAction>}
          onCreateSupplement={(payload) =>
            actions.createSupplement(payload) as Promise<DispatchedAction>
          }
          onRemoveSupplement={(payload) =>
            actions.removeSupplement(payload) as Promise<DispatchedAction>
          }
          onUpsertAssignment={(payload) =>
            actions.upsertAssignment(payload) as Promise<DispatchedAction>
          }
          onRemoveAssignment={(payload) =>
            actions.removeAssignment(payload) as Promise<DispatchedAction>
          }
          onQueryOptions={(payload) => void actions.queryOptions(payload)}
        />
      )}
    </Page>
  );
}
